import React, { JSX } from "react";
import Headline from "./Headline";
import PostsApi from "../../api-services/posts-api.service";
import { Link, useParams } from "react-router-dom";
import { notification } from "antd";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import HomeLink from "../../widgets/HomeLink";
import { Post } from "../../interfaces/post.interface";

interface IPostShowPageState {
  header: JSX.Element,
  banner: string,
  breadcrumbs: any[],
  type: string,
  blog: Post
}

const post = {
  "ice-visa-services": {
    category: "ice_visa_services", 
    header: "VISA", 
    banner: "/iceholidays-assets/images/ice-visa-services_about_us.png",
  }
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()}/>;
}

class PostShowPage extends React.Component <{params}>  {
  postsApi = new PostsApi;

  state = {
    header: null,
    banner: "",
    breadcrumbs:[],
    type: this.props.params['type'],
    blog: {title: "", thumbnail: "", content: ""},
  }

  componentDidMount() {
    this.getPosts(this.state.type);    
  }

  componentDidUpdate(prevProps: Readonly<{ params: any; }>, prevState: Readonly<{}>, snapshot?: any): void {    
    const type = this.props.params['type'];
    if(prevProps.params.type != type){
      this.setState({blog: {content: ""}})
      this.getPosts(type);
    }
  }

  getPosts(type){
    const category = post[type]?.category;
    const header = post[type]?.header;
    const breadcrumb = post[type]?.breadcrumb;
    const breadcrumbs = [
      { title: <HomeLink/>},
      { title: breadcrumb || header},
    ];
    this.setState({breadcrumbs, header, banner: post[type]?.banner})

    this.postsApi.getPosts(category)
    .then(({posts}) => {
      if(posts.length > 0){
        this.setState({blog: posts[0]})
      }
    })
    .catch(error => {
      notification.error({ message: `An error occured while loading ${header}.`});
    });
  }


  render(){
    const {blog, header, breadcrumbs, banner} = this.state;
    return blog && (
      <div className="static-page">
        <Headline showSearch={false} bannerImage={banner} breadcrumbs={breadcrumbs}>
          <span className="title">
            {header}
          </span>
        </Headline>

        <div className="static-show-page_body">
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
        </div>
      </div>
    )
  }
}


export default withParams(PostShowPage);